<template>
  <div id="app" class="container">
    <div v-show="loaded">
      <header-bar/>
      <router-view />
      <!--footer-bar/-->
    </div>
    <div v-show="!loaded" class="spinner-container animated">
      <svg v-show="loading.spin" class="spinner-figure" viewBox="0 0 44 44">
        <circle class="path" cx="22" cy="22" r="20" fill="none" stroke-width="4"></circle>
      </svg>
      <div v-show="loading.message" class="spinner-message">
        <span>{{ loading.message }}</span>
        <!--pre v-html="loading.buttons"/-->
        <div v-show="loading.buttons.length">
          <b-button
            type="info"
            v-for="(item, index) in loading.buttons"
            :key="index"
            @click="item.click">
              <span>{{ item.label }}</span>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import HeaderBar from '@/components/HeaderBar'
// import FooterBar from '@/components/FooterBar'
export default {
  name: 'home',
  components: {
    HeaderBar
    // FooterBar
  },
  computed: {
    ...mapState([
      'loaded',
      'loading'
    ])
  },
  mounted () {
    window.addEventListener('scroll', function (e) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      if (scrollTop > 100) {
        document.querySelectorAll('.top').forEach(e => e.classList.add('fixed'))
      } else {
        document.querySelectorAll('.top').forEach(e => e.classList.remove('fixed'))
      }
    })
  }
}
</script>

<style>
  :root {
    --themecolor:#00000033
  }
</style>
